import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { WritableComputedRef, computed } from "vue";
import TwLabel from "../TwLabel.vue";
import TwRadioButton from "../TwRadioButton.vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: '7.SkinTypeDescription',
  setup(__props) {

const store = useStore();

const skinTypeDescription: WritableComputedRef<string> = computed({
  get: () => store.state.form.skin_type_description,
  set: (value) => store.dispatch("updateSkinTypeDescription", value),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[skinTypeDescription.value == null ? 'bg-red-500' : ''], "p-2"])
  }, [
    _createVNode(TwLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("describe_your_skin_type")), 1)
      ]),
      _: 1
    }),
    _createVNode(TwRadioButton, {
      name: "skin_type_description",
      modelValue: skinTypeDescription.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((skinTypeDescription).value = $event)),
      options: [
        { label: _ctx.$t('skin_type_creamy'), value: 'skin_type_creamy' },
        { label: _ctx.$t('skin_type_light'), value: 'skin_type_light' },
        { label: _ctx.$t('skin_type_light_matte'), value: 'skin_type_light_matte' },
        { label: _ctx.$t('skin_type_matte'), value: 'skin_type_matte' },
        { label: _ctx.$t('skin_type_brown'), value: 'skin_type_brown' },
        { label: _ctx.$t('skin_type_black'), value: 'skin_type_black' },
      ]
    }, null, 8, ["modelValue", "options"])
  ], 2))
}
}

})